import React from 'react';

const StarBadge = ({ text, color = 'bg-rush-pink', textColor = 'text-white', size = 'md', rotate = false, className = '' }) => {
  const sizeClasses = {
    sm: 'w-16 h-16 text-[8px]',
    md: 'w-20 h-20 text-[10px]',
    lg: 'w-24 h-24 text-xs',
    xl: 'w-32 h-32 text-sm'
  };

  return (
    <div className={`relative ${rotate ? 'animate-star-spin' : ''} ${className}`}>
      <div className={`${sizeClasses[size]} ${color} star-8 flex items-center justify-center`}>
        <span className={`${textColor} font-bold uppercase text-center leading-tight px-2`}>
          {text}
        </span>
      </div>
    </div>
  );
};

export default StarBadge;
